<template>
  <div class="lead-form" @keyup.enter="onNext(-1)" tabindex="0">
    <div class="loading-data"></div>
    <LCPagination :currentStep="currentStep" v-if="currentStep >= 2 && currentStep <= 6" class="is-hidden-mobile"/>
    <LCBackground :currentStep="currentStep"/>
    <LCStepWord :currentStep="currentStep"/>
    <LCStepBar
      v-if="currentStep < 7"
      :currentStep="currentStep"
      :enableNext="canGoNext"
      @back="onBack"
      @next="onNext"
    />

    <a href="https://platforme.com/">
      <img src="@/assets/logo.svg" class="logo" />
    </a>
    <div ref="slideHolder" class="slide-content" v-if="form">
      <transition
        mode="out-in"
        :enter-active-class="enterAnimClass"
        :leave-active-class="leaveAnimClass"
      >
        <component
          :is="currentComponent"
          :ref="currentComponent"
          :form="form"
          :showScheduler="showScheduler"
          @validated="enableNext"
          @scheduled="onNext(7)"
          @back="onBack"
        />
      </transition>
    </div>
  </div>
</template>

<script>
  import Vue from 'vue'
  import { DEFAULT_LEAD_VALUES } from '@/graphql/queries/leads'
  import _ from 'lodash'

  import LCBackground from '@/components/leads_catcher/LCBackground.vue'
  import LCStepBar from '@/components/leads_catcher/LCStepBar.vue'
  import LCStepWord from '@/components/leads_catcher/LCStepWord.vue'
  import LCPagination from '@/components/leads_catcher/LCPagination.vue'

  import LeadFormIntro from '@/components/leads/form/Intro.vue'
  import LeadFormInfo from '@/components/leads/form/Info.vue'
  import LeadFormMarket from '@/components/leads/form/Market.vue'
  import LeadFormProduct from '@/components/leads/form/Product.vue'
  import LeadFormComments from '@/components/leads/form/Comments.vue'
  import LeadFormReview from '@/components/leads/form/Review.vue'
  import LeadFormSuccess from '@/components/leads/form/Success.vue'

  export default {
    name: 'LeadForm',
    components: {
      LCStepBar,
      LCBackground,
      LCStepWord,
      LCPagination,
      LeadFormIntro,
      LeadFormInfo,
      LeadFormMarket,
      LeadFormProduct,
      LeadFormComments,
      LeadFormReview,
      LeadFormSuccess
    },
    data: function() {
      return {
        modelNamePlural: 'leads',
        id: null,
        form: JSON.parse(JSON.stringify(DEFAULT_LEAD_VALUES)),
        direction: 'right',
        currentStep: 1,
        showScheduler: false,
        canGoNext: false,
        stepComponents: {
          "1": LeadFormIntro,
          "2": LeadFormInfo,
          "3": LeadFormMarket,
          "4": LeadFormProduct,
          "5": LeadFormComments,
          "6": LeadFormReview,
          "7": LeadFormSuccess,
        }
      }
    },
    computed: {
      byId() {
        return this.$store.getters[`${this.modelNamePlural}/byId`]
      },
      lead() {
        return this.byId(this.id)
      },
      enterAnimClass() {
        let name = 'animate__animated'
        if (this.direction == 'right') {
          name = `${name} animate__fadeInRight`
        } else {
          name = `${name} animate__fadeInLeft`
        }
        return name
      },
      leaveAnimClass() {
        let name = 'animate__animated'
        if (this.direction == 'right') {
          name = `${name} animate__fadeOutLeft`
        } else {
          name = `${name} animate__fadeOutRight`
        }

        return name
      },
      currentComponent() {
        return this.stepComponents[this.currentStep.toString()]
      }
    },
    watch: {
      lead() {
        if (this.id) {
          this.form = Object.assign({}, this.lead)
                              }
      },
      currentStep() {
        this.$nextTick(() => {
          window.scrollTo(0,0)
        });
      }
    },
    methods: {
      save(args) {
        return this.$store.dispatch(`${this.modelNamePlural}/save`, args)
      },
      submit(page) {
        this.form.validatedSteps = this.validatedSteps()
        const sanitizedForm = _.pick(this.form, _.keys(DEFAULT_LEAD_VALUES))

        this.save({id: this.id, form: sanitizedForm}).then((response) => {
          if (response) {
            const responseId = response.data.leads.id
            this.id = responseId

            this.currentStep = page
          }
        })
      },
      onBack() {
        if (this.currentStep == 6 && this.showScheduler == true) {
          this.showScheduler = false
        } else {
          this.direction = 'left'
          this.currentStep--
        }
      },
      onNext(page) {
        this.direction = 'right'

        if (page == -1) {
          if (this.$refs[this.stepComponents[this.currentStep.toString()]].validate()) {
            if (this.currentStep == 6) {
              this.showScheduler = true
            } else if (this.currentStep >= 2) {
              this.submit(this.currentStep + 1)
            } else {
              this.currentStep++
            }
          }
        } else if (this.currentStep > page) {
          this.direction = 'left'
          this.submit(page)
        } else {
          let valid = true
          for (let i = 1; i < page; i++) {
            let ComponentClass = Vue.extend(this.stepComponents[i.toString()])
            var instance = new ComponentClass({ propsData: { form: this.form } })

            if (!instance.validate()) {
              valid = false
            }
          }

          if (valid) {
            this.submit(page)
          }
        }
      },
      enableNext(validated) {
        if (validated) {
          this.canGoNext = true
        } else {
          this.canGoNext = false
        }
      },
      validatedSteps() {
        let validSteps = 0
        let validComp = []
        const stepKeys = Object.keys(this.stepComponents)
        for (let i = 0; i < stepKeys.length; i++) {
          let ComponentClass = Vue.extend(this.stepComponents[stepKeys[i]])
          var instance = new ComponentClass({ propsData: { form: this.form } })

          if (instance.validate()) {
            validSteps++
            validComp.push(this.stepComponents[stepKeys[i]].name)
          }
        }

        return validSteps - 3 // remove non fillable steps
      }
    },
  }
</script>

<style lang="scss" scoped>
.loading-data {
  width: 0px;
  height: 0px;
  position: absolute;
}

.logo {
  width: 54px;
  height: 28px;
  margin-top: 26px;
  margin-left: 22px;
  position: relative;
  z-index: 1000;

  @media screen and (min-width: $tablet) {
    position: fixed;
    margin-top: 39px;
    margin-left: 50px;
  }
}

.slide-content {
  position: relative;
  overflow: hidden;
}

.lead-form {
  position: absolute;
  width: 100%;
  height: 100%;
}
// .fade-enter-active, .fade-leave-active {
//   transition: opacity .5s;
// }
// .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
//   opacity: 0;
// }

.animate__fadeInRight,
.animate__fadeInLeft,
.animate__fadeOutLeft,
.animate__fadeOutRight {
  --animate-duration: 0.5s;
  transition-delay: 1ms;
}

.slide-enter-active, .slide-leave-active {
  position: relative;
}

.slide-enter-active,
.slide-leave-enter {
    transform: translateX(0);
    transition: all .3s linear;
}
.slide-enter,
.slide-leave-to {
    transform: translateX(100%);
}
</style>
